<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h6>Departments Sign Up</h6>
        <canvas id="departmentChart"></canvas>
      </div>
      <div class="col-md-6">
        <h6>Roles Sign Up by</h6>
        <center>
          <select v-on:change="countRolesByDepartment" v-model="selectedDepartment">
            <option selected value="Select Department">Select Dept</option>
            <option v-for="d in departments">{{d}}</option>
          </select>
        </center>
        <canvas id="roleByDeptChart"></canvas>
      </div>
      <div class="col-md-6 mt-5">
        <h6>Sign Up By Congregation</h6>
        <canvas id="SignUpByCongregationChart"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../commons/http.js";
import Chart from "chart.js";

export default {
  data: function() {
    return {
      listOfMr: [],
      departmentSignUp: {},
      departments: [],
      roleSignUp: {},
      allRoleSignUp: {},
      selectedDepartment: "Select Department",
      congregationSignUp: {},
      chart: {
        roleByDeptChart: ""
      }
    };
  },
  methods: {
    renderSignUpByCongregationChart: function() {

      let labels = [];
      let dataPoints = [];
      let colors = [];
      let borderColors = [];

      for(let key in this.congregationSignUp){
        if(this.congregationSignUp.hasOwnProperty(key)){
          labels.push(key);
          dataPoints.push(this.congregationSignUp[key]);
          colors.push(this.randomColor());
          borderColors.push(this.randomColor());
        }
      }

      let ctx = document.getElementById("SignUpByCongregationChart").getContext("2d");
      var myChart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: labels,
          datasets: [
            {
              label: "# of Tomatoes",
              data: dataPoints,
              backgroundColor: colors,
              borderColor: borderColors,
              borderWidth: 1
            }
          ]
        },
        options: {
          responsive: false,
          scales: {
            xAxes: [
              {
                ticks: {
                  maxRotation: 90,
                  minRotation: 80
                }
              }
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true
                }
              }
            ]
          }
        }
      });
    },    
    renderRoleChartByDepartment: function() {
      let ctx = document.getElementById("roleByDeptChart").getContext("2d");
      let roles = [];
      let rolesCount = [];
      let bgColor = [];

      for (let key in this.roleSignUp) {
        if (this.roleSignUp.hasOwnProperty(key)) {
          roles.push(key);
          rolesCount.push(this.roleSignUp[key]);
          bgColor.push(this.randomColor());
        }
      }
      if (this.chart.roleByDeptChart !== "") {
        this.chart.roleByDeptChart.destroy();
      }

      this.chart.roleByDeptChart = new Chart(ctx, {
        // The type of chart we want to create
        type: "doughnut",

        // The data for our dataset
        data: {
          labels: roles,
          datasets: [
            {
              data: rolesCount,
              backgroundColor: bgColor
            }
          ]
        },

        // Configuration options go here
        options: {
          cutoutPercentage: 50
        }
      });
    },
    renderDepartmentChart: function() {
      let ctx = document.getElementById("departmentChart").getContext("2d");

      let departments = [];
      let departmentsCount = [];
      let bgColor = [];

      for (let key in this.departmentSignUp) {
        if (this.departmentSignUp.hasOwnProperty(key)) {
          departments.push(key);
          departmentsCount.push(this.departmentSignUp[key]);
          bgColor.push(this.randomColor());
        }
      }
      this.departments = departments;

      let chart = new Chart(ctx, {
        // The type of chart we want to create
        type: "doughnut",

        // The data for our dataset
        data: {
          labels: departments,
          datasets: [
            {
              data: departmentsCount,
              backgroundColor: bgColor
            }
          ]
        },

        // Configuration options go here
        options: {
          cutoutPercentage: 50
        }
      });
    },
    list: async function() {
      try {
        let response = await http.get("/ministryrequest?limit=999");
        this.listOfMr = response.data;
        this.countDepartmentSignUp();
        this.countByCongregation();
      } catch (err) {
        console.error("GET /ministryrequest err", err);
      }
    },
    countDepartmentSignUp: function() {
      this.departmentSignUp = {};
      this.listOfMr.forEach(mr => {
        if (this.departmentSignUp[mr.ministryRole.department]) {
          this.departmentSignUp[mr.ministryRole.department]++;
        } else {
          this.departmentSignUp[mr.ministryRole.department] = 1;
        }
      });
      this.renderDepartmentChart();
    },
    countRolesByDepartment: function() {
      this.roleSignUp = {};
      this.listOfMr.forEach(mr => {
        if (mr.ministryRole.department !== this.selectedDepartment) {
          return;
        }
        if (this.roleSignUp[mr.ministryRole.name]) {
          this.roleSignUp[mr.ministryRole.name]++;
        } else {
          this.roleSignUp[mr.ministryRole.name] = 1;
        }
      });
      this.renderRoleChartByDepartment();
    },    
    countByCongregation: function() {
      this.listOfMr.forEach(mr => {
        if (this.congregationSignUp[mr.congregation]) {
          this.congregationSignUp[mr.congregation]++;
        } else {
          this.congregationSignUp[mr.congregation] = 1;
        }
      });
      this.renderSignUpByCongregationChart();
    },
    randomColor: function() {
      var r = Math.floor(Math.random() * 255);
      var g = Math.floor(Math.random() * 255);
      var b = Math.floor(Math.random() * 255);
      return "rgb(" + r + "," + g + "," + b + ")";
    }
  },
  beforeMount: async function() {
    this.list();
    if (!(await http.isLoggedIn(true))) {
      this.$router.push("/adminhome");
    }
  }
};
</script>

<style>
</style>